module.exports = __webpack_public_path__ + "media/images/athletes/2423-6f074696dd230bb5e00c84fc5fe7eb28.png";